import { render } from "./VehicleAdd.vue?vue&type=template&id=1b14fd88&scoped=true"
import script from "./VehicleAdd.vue?vue&type=script&lang=js"
export * from "./VehicleAdd.vue?vue&type=script&lang=js"

import "./VehicleAdd.vue?vue&type=style&index=0&id=1b14fd88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b14fd88"]])

export default __exports__